import { Link } from 'react-router-dom';

/**
 * AppFooter — standard footer for authenticated dashboards.
 *
 * Renders a role-aware link row:
 *   - School Admin (`role === 'employer'`): Pricing • Terms • Privacy • Contact Us
 *   - Sub user     (`role === 'toc'`):                Terms • Privacy • Contact Us
 *
 * Layout mirrors the public marketing footer for visual consistency.
 */
export default function AppFooter({ role }) {
  const showPricing = role === 'employer';
  return (
    <footer
      className="bg-slate-950 text-slate-400 py-8 mt-12"
      data-testid="app-footer"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm">
            {showPricing && (
              <>
                <Link
                  to="/pricing"
                  className="hover:text-white transition-colors"
                  data-testid="app-footer-pricing-link"
                >
                  Pricing
                </Link>
                <span className="text-slate-600" aria-hidden="true">|</span>
              </>
            )}
            <Link
              to="/terms"
              className="hover:text-white transition-colors"
              data-testid="app-footer-terms-link"
            >
              Terms of Service
            </Link>
            <span className="text-slate-600" aria-hidden="true">|</span>
            <Link
              to="/privacy"
              className="hover:text-white transition-colors"
              data-testid="app-footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <span className="text-slate-600" aria-hidden="true">|</span>
            <Link
              to="/contact"
              className="hover:text-white transition-colors"
              data-testid="app-footer-contact-link"
            >
              Contact Us
            </Link>
          </div>
          <p className="text-xs md:text-sm text-slate-500">
            © 2026 ExpressSub. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
